import Vue from 'vue'
import App from './App.vue'
import router from './router'
import FirebaseVue from './firebase'
import VueHZoom from 'vue-h-zoom'
// import VueChatScroll from './vue-chat-scroll'
import './assets/scss/app.scss'

Vue.use(FirebaseVue)
// Vue.use(VueChatScroll)
Vue.config.productionTip = false
Vue.use(VueHZoom)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
